import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';

import resources from "../../data/resources";
import MemberData from "../../data/MemberData";
import Toast from "../extras/Toast";

class MemberEditDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            data: {
                user: {
                    first_name: '',
                    last_name: '',
                    email: ''
                },
                id: 0
            },
            first_name_error: false,
            last_name_error: false,
            email_error: false,
            index: null
        };

        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
    }

    handleEmailChange = (event) => {
        let email = update(this.state, {
            data: {
                user: {
                    email: {
                        $set: event.target.value.toLowerCase().trim()
                    }
                }
            }
        });
        this.setState(email);
        if (event.target.value.trim() === '') {
            this.setState({email_error: true})
        } else {
            if (resources.validators.isValidEmailAddress(event.target.value)) {
                this.setState({email_error: false})
            } else {
                this.setState({email_error: true})
            }
        }
    };

    handleFirstNameChange = (event) => {
        let first_name = update(this.state, {
            data: {
                user: {
                    first_name: {
                        $set: event.target.value
                    }
                }
            }
        });
        this.setState(first_name);
        if (event.target.value.trim() === '') {
            this.setState({first_name_error: true})
        } else {
            this.setState({first_name_error: false});
        }
    };

    handleLastNameChange = (event) => {
        let last_name = update(this.state, {
            data: {
                user: {
                    last_name: {
                        $set: event.target.value
                    }
                }
            }
        });
        this.setState(last_name);
        if (event.target.value.trim() === '') {
            this.setState({last_name_error: true})
        } else {
            this.setState({last_name_error: false});
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.data.user.first_name === '') {
            this.setState({first_name_error: true});
        } else if (this.state.data.user.last_name === '') {
            this.setState({last_name_error: true});
        } else if (this.state.data.user.email === '' || !resources.validators.isValidEmailAddress(this.state.data.user.email)) {
            this.setState({email_error: true});
        } else {
            this.setState({disabled_button: true});
            if (this.state.data.user.id) {
                MemberData.update(this.state.data, (res) => {
                    if (res.update) {
                        let data = this.state.data;
                        data.user.full_name = `${this.state.data.user.first_name} ${this.state.data.user.last_name}`;
                        this.props.callbackUpdateData(data, this.state.index);
                        this.refs.toast.show({message: 'Información actualizada!', type: 'success'});
                    } else {
                        this.refs.toast.show({message: 'El correo electrónico ya es utilizado!', type: 'success'});
                    }
                    this.setState({disabled_button: false, open: false});
                });
            }
        }
    };

    handleOpen(data, index) {
        this.setState({data, index, open: true});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {
        return (
            <div>
                <Modal size='tiny' dimmer='inverted' open={this.state.open} onClose={this.handleClose}>
                    <Modal.Header>Actualizar Usuario</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid divided>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Input label='Nombre' placeholder='Nombre'
                                                        value={this.state.data.user.first_name}
                                                        onChange={this.handleFirstNameChange}
                                                        error={this.state.first_name_error}/>
                                            <Form.Input label='Apellido' placeholder='Apellido'
                                                        value={this.state.data.user.last_name}
                                                        onChange={this.handleLastNameChange}
                                                        error={this.state.last_name_error}/>
                                            <Form.Input type='email' label='Email' placeholder='Email'
                                                        value={this.state.data.user.email}
                                                        onChange={this.handleEmailChange}
                                                        error={this.state.email_error}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' loading={this.state.disabled_button} labelPosition='left'
                                onClick={this.handleSubmit} content='Actualizar'/>
                    </Modal.Actions>
                </Modal>
                <Toast ref='toast'/>
            </div>
        );
    }
}

export default MemberEditDialog;



// WEBPACK FOOTER //
// ./src/components/security/MemberEditDialog.js